import { Injectable, Inject } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService,
         DwOrmDataService, DwOrmDataServiceToken, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo,
         DwMessagingService, DwMessageSeverity } from '@devwareapps/devware-cap';
import { CodeValuePermitType, Permits2PermitEntity, PermitsV2MetaDataItemNames, PermitsV2MetaDataLookups } from '../meta-data/permitsv2-meta-data.service';
import { map } from 'rxjs/operators';

@DwCustomContextDefinition({
    keyName: 'permitV2JnWjidContext',
    display: 'Permit V2 - JN/WJID',
    isGlobal: false,
    parentItem: PermitsV2MetaDataItemNames.Permits2Permit
})
@Injectable()
export class PermitV2JnWjidContextService extends DwCustomContextBase {
    wjid: DwLookupInfo[];

    constructor(
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
        protected messageService: DwMessagingService
    ){
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        const cxtFunc = (resolvedContext => {
            const permit: Permits2PermitEntity = resolvedContext?.data;
            const jn = permit?.JobNumberId ?? 0;

            if (jn > 0)
                return this
                    .dwMetaDataService.getLookup(PermitsV2MetaDataLookups.WJIDByJobNumber, [{ ParamName: 'JobNumberId', ParamValue: jn.toString() }])
                    .pipe(map(wjid => {
                        this.wjid = wjid;
                        return { 
                            WjidCount : this.wjid?.length ?? 0
                        }
                    }));
            else    
                return { WjidCount : 0 };
        });
        contextDef.getCustomContextFunction = cxtFunc;
        contextDef.debounceTimeMs = 500;

        contextDef.attributes = [];
        var permitTypesCountAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
            'WjidCount', 'WJID Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
    }
   
}
